import { toastr } from 'react-redux-toastr';

function triggerValidation(triggers) {
  let triggerValues = true;
  let triggerTextAction = true;
  let triggerSquare = true;

  let inactivityTime = true;
  let timeTriggerTextAction = true;
  let timeTriggerSquare = true;

  triggers.forEach((trigger, index) => {
    if (trigger.activator === 'trigger') {
      if (trigger.receivedValues.length <= 0) {
        triggerValues = false;
        toastr.error(
          'Erro',
          `Por favor informe palavras para o gatilho da Regra de sessão ${
            index + 1
          }`
        );
      } else if (trigger.action === 'message') {
        if (trigger.message === '') {
          triggerTextAction = false;
          toastr.error(
            'Erro',
            `Por favor informe a mensagem do gatilho da Regra de sessão ${
              index + 1
            }`
          );
        }
      } else if (trigger.action === 'square') {
        if (trigger.square === '') {
          triggerSquare = false;
          toastr.error(
            'Erro',
            `Por favor informe o bloco a ser redirecionado da Regra de sessão ${
              index + 1
            }`
          );
        }
      }
    } else if (trigger.activator === 'time') {
      if (!trigger.inactivityTime) {
        inactivityTime = false;
        toastr.error(
          'Erro',
          `Por favor informe o tempo de inatividade para a Regra de Sessão ${
            index + 1
          }`
        );
      } else if (trigger.action === 'message') {
        if (trigger.message === '') {
          timeTriggerTextAction = false;
          toastr.error(
            'Erro',
            `Por favor informe a mensagem do gatilho da Regra de sessão ${
              index + 1
            }`
          );
        }
      } else if (trigger.action === 'square') {
        if (trigger.square === '') {
          timeTriggerSquare = false;
          toastr.error(
            'Erro',
            `Por favor informe o bloco a ser redirecionado da Regra de sessão ${
              index + 1
            }`
          );
        }
      }
    }
  });

  if (triggerValues === false) {
    return false;
  }

  if (triggerTextAction === false) {
    return false;
  }

  if (triggerSquare === false) {
    return false;
  }

  if (inactivityTime === false) {
    return false;
  }

  if (timeTriggerTextAction === false) {
    return false;
  }

  if (timeTriggerSquare === false) {
    return false;
  }
  return true;
}

export default triggerValidation;
